import React from 'react';
import {
  IonButton,
  IonButtons,
  IonContent,
  IonFooter,
  IonHeader,
  IonModal,
  IonText,
  IonTitle,
  IonToolbar,
} from '@ionic/react';

/**
 * Selector de “modo de gestión” para errores SIN-ASIGNACION.
 *
 * Requisitos del negocio:
 * - Mantener Reemplazo Rápido (flujo existente).
 * - Permitir gestionar vía Limpieza Profunda (LP).
 * - Mostrar Orden de Servicio como placeholder (sin lógica todavía).
 */

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onElegirReemplazoRapido: () => void;
  onElegirLimpiezaProfunda: () => void;
};

const GestionSinAsignacionSelectorModal: React.FC<Props> = ({
  isOpen,
  onClose,
  onElegirReemplazoRapido,
  onElegirLimpiezaProfunda,
}) => {
  return (
    <IonModal isOpen={isOpen} onDidDismiss={onClose}>
      <IonHeader>
        <IonToolbar color="primary">
          <IonTitle>Gestionar SIN-ASIGNACION</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={onClose}>Cerrar</IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>

      <IonContent style={{ padding: 16 }}>
        <IonText color="medium">
          Selecciona cómo quieres gestionar este caso.
        </IonText>

        <div style={{ marginTop: 16, display: 'grid', gap: 12 }}>
          <IonButton expand="block" onClick={onElegirReemplazoRapido}>
            REEMPLAZO RÁPIDO
          </IonButton>

          <IonButton expand="block" fill="outline" onClick={onElegirLimpiezaProfunda}>
            LIMPIEZA PROFUNDA
          </IonButton>

          {/* Placeholder pedido: visible, pero sin acción */}
          <IonButton expand="block" fill="clear" disabled>
            ORDEN DE SERVICIO (PRÓXIMAMENTE)
          </IonButton>
        </div>
      </IonContent>

      <IonFooter>
        <IonToolbar>
          <IonButtons slot="end">
            <IonButton onClick={onClose}>Cancelar</IonButton>
          </IonButtons>
        </IonToolbar>
      </IonFooter>
    </IonModal>
  );
};

export default GestionSinAsignacionSelectorModal;
